import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sgkb941d',
  templateUrl: './sgkb941d.component.html',
  styleUrl: './sgkb941d.component.scss'
})
export class Sgkb941dComponent implements OnInit, OnDestroy {

  parentForm: UntypedFormGroup = this.fb.group({
  });

  @Output() errorMessageModelArray: Array<SgAriaMessage> = [];

  // 画面間パラメータ（区分）
  mode?: string;

  /** 画面タイトル */
  dispTitle: string;

  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private completeDataService: CompleteDataService) {
  }

  /**
   * onInit
   * @memberof Sgkb941dComponent
   */
  ngOnInit(): void {
    // 画面間パラメータ受け取り（区分）
    this.mode = this.route.snapshot.paramMap.get('mode');
    // 区分が新規登録の場合
    if (this.mode === 'create') {
      this.dispTitle = 'ＷＴ契約変更受付';
      // 区分が照会の場合
    } else if (this.mode === 'read') {
      this.dispTitle = 'ＷＴ契約変更受付照会';
    }
  }

  /**
   * タイトル表示設定
   * @memberof Sgkb941dComponent
   */
  onTitleChange(newTitle: string) {
    this.dispTitle = newTitle;
  }

  /**
   * エラーメッセージ表示設定
   * @memberof Sgkb941dComponent
   */
  pushSgAriaMessage(message: string): void {
    let errorMessageModelForEditArray: Array<SgAriaMessage> = [...this.errorMessageModelArray];
    errorMessageModelForEditArray.push({
      message: message
      , messageClass: "mat-card-background-error"
      , icon: "cancel"
      , iconClass: "mat-icon-color-error"
    });
    this.errorMessageModelArray = errorMessageModelForEditArray;
  }

  /**
   * onDestroy
   * @memberof Sgkb941dComponent
   */
  ngOnDestroy(): void {
    // Do nothing.
  }
}
